import React, { useContext, useRef, useEffect } from "react";
import { Divider, Row, Col } from "antd";
import moment from "moment";
import { withRouter, Link } from "react-router-dom";
import PrintComponents from "react-print-components";
import  PropTypes from 'prop-types';
import {
  PagesHeading,
  SectionSpacing,
  PageSectionHeading,
  DataHeading,
  DisplayFlex,
} from "../../../../../../CommonComponents/commonStyles";
import Breadcrumb from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import Print from "../../../../../../CommonComponents/svgs/Print";
import {
  ProcessingContainer,
  FlexContainer,
  ButtonWrapper,
} from "./styles";
import {
  NavigationBtnContainer,
  Heading,
  SectionHeading,
  PrintDiv,
  PrintButton,
  CustomTableForPrint,
  CustomSectionSpacing
} from "../../styles";
import Context from "../../context";
import ExchangeOptions from "../exchangeOptions";
import ExchangeSchedule from "../exchangeSchedule";
import FromTable from "../exchangeReview/FromTable";
import ToTable from "../exchangeReview/ToTable";
import {
  ScheduleType as ScheduleTypeConstants,
  ExchangeType as ExchangeTypeConstants,
  Frequency as FrequencyConstants,
  DateFormat,
} from "../../constants";
import SpawnTable from "./SpawnTable";
import SoftAlert from "../../../../../../CommonComponents/Info/SoftAlert/SoftAlert.js";
import ReactToPrint from "react-to-print";
import printIcon from "../../../../../../assets/icons/print.svg";
import {
  ContentMessage,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import BreadcrumbComponent from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
/**
 * NOTE: This component display values based on the output of new single exchange or new recurring exchange APIs only
 */

const Confirmation = (props) => {
    const {
    history,
    handleExit,
    exchangeDetails: exchange = {},
    id,
    location,
    isLoading,
  } = props;
  const context = useContext(Context);
  const { exchangeContext={} } = context;
  const { from={}, to={}, spawns } = exchangeContext;
  const componentRef = useRef();
  const isPrint = () => window.matchMedia("print");
  useEffect(() => {
    window.scrollTo(0, 0);
    // WORKAROUND: Listen to back button event and navigate to current page again.
    window.onpopstate = (event) => {
      history.go(1);
    };
  }, []);

  const breadcrumbRoutes = [
    {
      routeName: "Home",
      path: "/",
    },
    {
      routeName: "Investments",
      path: "/investments",
    },
    {
      routeName: "Recommend an Exchange",
      path: "/investments/recommend-an-exchange",
    },
    {
      routeName: "Review Exchange and Submit",
      path: `/investments/recommend-an-exchange/${id}/confirmation`,
    },
  ];

  const viewAllExchanges = () => {
    history.push("/investments/exchange-activity");
  };

  const printClicked = () => {
    try {
      const scheduleTypeLabel =
      from.scheduleType === ScheduleTypeConstants.onetime
        ? "One Time Exchange"
        : "Recurring Exchange";
      initiateTracking(
        "print",
        "Exchange Request Confirmation",
        "",
        `Print - ${scheduleTypeLabel}`
      );
      return componentRef.current;
    } catch (error) {
      recordError(error);
    }  
  };

  const CustomPrintTable = ({dataSource,columns}) => {
    return (
        <CustomTableForPrint
            className="tblForPrint">
            <thead>
                <tr>
                {columns.map(data => {
                    return (
                        <th>
                            <div>{typeof data.title == 'string' ? data.title : data.title()}</div>
                        </th>
                    )
                })}
                </tr>
            </thead>
            <tbody>
            {dataSource.map(data => {
                return (
                    <tr>
                        {columns.map(val => {
                            return (
                                <td>{val.render(data)}</td>
                            )
                        })}
                    </tr>
                )
            })}
            </tbody>
        </CustomTableForPrint>
    )
}

const CustomPrintSpawnTable = ({dataSource,columns}) => {
  return (
      <CustomTableForPrint>
          <thead>
              <tr>
              {columns.map(data => {
                  return (
                      <th>
                          <div>{typeof data.title == 'string' ? data.title : data.title()}</div>
                      </th>
                  )
              })}
              </tr>
          </thead>
          <tbody>
          {dataSource.map(data => {
              return (
                  <tr>
                      {columns.map(val => {
                          return (
                              <td>{val.render ? val.render(data[val.key] , data): data[val.key]}</td>
                          )
                      })}
                  </tr>
              )
          })}
          </tbody>
      </CustomTableForPrint>
  )
}

  if (isLoading) return <Preloader data-test="loader"/>;
  return (
    <div data-test="confirmationWrapper">
      <BreadcrumbComponent breadcrumbRoutes={breadcrumbRoutes} data-test="breadcrumb" />
      <div ref={componentRef}>
        <PagesHeading>
          <ContentMessage
            page="Exchange confirmation"
            type={Types.PAGE_TITLE_DESCRIPTION}
            property="field_page_title"
            defaultMessage="Exchange request confirmation"
          />
        </PagesHeading>
        <SectionSpacing>
          <SoftAlert
            className="altConfirmation"
            mainbody={
              <ContentMessage
                page="Recommend an Exchange Confirmation"
                type={Types.PAGE_DISCLAIMERS}
                property="field_disclaimer_content"
                html={true}
                defaultMessage="All investment exchange recommendations are subject to approval.Learn more about <Link to='/'>exchange approval policies</Link>. Exchange recommendations submitted after the day’s trade cutoff may be processed the following business day. Exchanges involving large dollar amounts may be processed over multiple business days."
              />
            }
          />
        </SectionSpacing>
        <Divider />
        <SectionSpacing>
          <ProcessingContainer className="flex">
            <div className="flex confirmation-fields">
              <div>
                {from.scheduleType === ScheduleTypeConstants.recurring ? (
                  <DisplayFlex>
                    <DataHeading>Schedule ID:</DataHeading>
                    <Heading className="ml-10">
                      {exchange.exchScheduleId}
                    </Heading>
                  </DisplayFlex>
                ) : (
                  <DisplayFlex>
                    <DataHeading>Transaction ID:</DataHeading>
                    <Heading className="ml-10">
                      {exchange.transactionId}
                    </Heading>
                  </DisplayFlex>
                )}
              </div>
              <DisplayFlex>
                <DataHeading>Entered Date:</DataHeading>
                <Heading className="ml-10">
                  {moment(exchange.enteredDate).format(DateFormat)}
                </Heading>
              </DisplayFlex>
            </div>

            <PrintComponents
              className="i_print"
              trigger={
                <PrintDiv>
                  <DisplayFlex className="hide-for-print">
                    <img src={printIcon} alt="print icon"/>
                    <PrintButton id="btnPrint" onClick={() => printClicked()}>
                      PRINT
                    </PrintButton>
                  </DisplayFlex>
                </PrintDiv>
              }
            >
              <div>
                <PagesHeading>
                  <ContentMessage
                    page="Exchange confirmation"
                    type={Types.PAGE_TITLE_DESCRIPTION}
                    property="field_page_title"
                    defaultMessage="Exchange request confirmation"
                  />
                </PagesHeading>
                <SectionSpacing>
                  <SoftAlert
                    className="altExchangeConfirmation"
                    mainbody={
                      <ContentMessage
                        page="Recommend an Exchange Confirmation"
                        type={Types.PAGE_DISCLAIMERS}
                        property="field_disclaimer_content"
                        html={true}
                        defaultMessage="All investment exchange recommendations are subject to approval.Learn more about <Link to='/'>exchange approval policies</Link>. Exchange recommendations submitted after the day’s trade cutoff may be processed the following business day. Exchanges involving large dollar amounts may be processed over multiple business days."
                      />
                    }
                  />
                </SectionSpacing>
                <Divider />
                <SectionSpacing>
                  <ProcessingContainer className="flex">
                    <div className="flex confirmation-fields">
                      <div>
                        {from.scheduleType ===
                        ScheduleTypeConstants.recurring ? (
                          <DisplayFlex>
                            <DataHeading>Schedule ID:</DataHeading>
                            <Heading className="ml-10">
                              {exchange.exchScheduleId}
                            </Heading>
                          </DisplayFlex>
                        ) : (
                          <DisplayFlex>
                            <DataHeading>Transaction ID:</DataHeading>
                            <Heading className="ml-10">
                              {exchange.transactionId}
                            </Heading>
                          </DisplayFlex>
                        )}
                      </div>
                      <DisplayFlex>
                        <DataHeading>Entered Date:</DataHeading>
                        <Heading className="ml-10">
                          {moment(exchange.enteredDate).format(DateFormat)}
                        </Heading>
                      </DisplayFlex>
                    </div>
                  </ProcessingContainer>
                </SectionSpacing>
                <Divider className="m0"/>
                <CustomSectionSpacing isPrint={true}>
                  <Row>
                    <ExchangeOptions
                      scheduleType={from.scheduleType}
                      exchangeType={from.exchangeType}
                      edit={false}
                      history={history}
                      id={id}
                      location={location}
                      tradeCutOffTime={exchange.tradeCutOffTime}
                    />
                    {from.scheduleType === ScheduleTypeConstants.recurring && (
                      <ExchangeSchedule
                        frequency={from.frequency}
                        numberOfExchanges={exchange.noOfExchanges}
                        startDate={from.exchangeStartDate}
                        endDate={from.endDate}
                        edit={false}
                        history={history}
                        id={id}
                        isViewEdit={false}
                      />
                    )}
                   </Row>
                </CustomSectionSpacing>
                <Divider className="m0"/>
                <SectionSpacing>
                  <FlexContainer>
                    <SectionHeading>Recommend exchange from</SectionHeading>
                  </FlexContainer>
                  <Row>
                    <Col xs={isPrint() ? 24 : 0} sm={24} lg={12}>
                      <FromTable
                        isPrintCheck={true}
                        printRender = {(columns) => <CustomPrintTable dataSource={from.pools} columns={columns} /> } 
                        dataSource={from.pools}
                        allocationType={from.allocationType}
                        exchangeType={from.exchangeType}
                        isConfirmation="true"
                      />
                    </Col>
                  </Row>
                </SectionSpacing>
                <Divider />
                <SectionSpacing>
                  <FlexContainer>
                    <SectionHeading>Recommend exchange to</SectionHeading>
                  </FlexContainer>
                  <Row>
                    <Col xs={isPrint() ? 24 : 0} sm={24} lg={12}>
                      <ToTable
                            dataSource={to.pools} 
                            isReview={false}
                            printRender = {(columns) => <CustomPrintTable columns={columns} dataSource={to.pools} /> }
                            isPrintCheck={true}
                     />
                    </Col>
                  </Row>
                </SectionSpacing>
                {from.scheduleType === ScheduleTypeConstants.recurring && (
                  <SectionSpacing>
                    <FlexContainer>
                      <SectionHeading>
                        Recommend exchange schedule
                      </SectionHeading>
                    </FlexContainer>
                    <Row>
                      <Col xs={isPrint() ? 24 : 0} sm={24} md={12} lg={12}>
                        <SpawnTable
                          isPrintCheck={true}
                          printRender = {(columns, dataSource) => <CustomPrintSpawnTable  data-test="customTablePrint" dataSource={dataSource} columns={columns} /> }   
                          dataSource={spawns} />
                      </Col>
                    </Row>
                    <Divider />
                  </SectionSpacing>
                )}
              </div>
            </PrintComponents>
          </ProcessingContainer>
        </SectionSpacing>
        <Divider className="m0"/>
        <CustomSectionSpacing>
          <Row>
            <ExchangeOptions
              scheduleType={from.scheduleType}
              exchangeType={from.exchangeType}
              edit={false}
              history={history}
              id={id}
              location={location}
              tradeCutOffTime={exchange.tradeCutOffTime}
            />
            {from.scheduleType === ScheduleTypeConstants.recurring && (
              <ExchangeSchedule
                frequency={from.frequency}
                numberOfExchanges={exchange.noOfExchanges}
                startDate={from.exchangeStartDate}
                endDate={from.endDate}
                edit={false}
                history={history}
                id={id}
                isViewEdit={false}
              />
            )}
             </Row>
        </CustomSectionSpacing>
        <Divider className="m0"/>
        <SectionSpacing>
          <FlexContainer>
            <SectionHeading>Recommend exchange from</SectionHeading>
          </FlexContainer>
          <Row>
            <Col xs={isPrint() ? 24 : 0} sm={24} lg={12}>
              <FromTable
                dataSource={from.pools}
                allocationType={from.allocationType}
                exchangeType={from.exchangeType}
                isConfirmation="true"
              />
            </Col>
          </Row>
        </SectionSpacing>
        <Divider />
        <SectionSpacing>
          <FlexContainer>
            <SectionHeading>Recommend exchange to</SectionHeading>
          </FlexContainer>
          <Row>
            <Col xs={isPrint() ? 24 : 0} sm={24} lg={12}>
              <ToTable dataSource={to.pools} isReview={false} />
            </Col>
          </Row>
        </SectionSpacing>
        {from.scheduleType === ScheduleTypeConstants.recurring && (
          <SectionSpacing>
            <FlexContainer>
              <SectionHeading>Recommend exchange schedule</SectionHeading>
            </FlexContainer>
            <Row>
              <Col xs={isPrint() ? 24 : 0} sm={24} md={12} lg={12}>
                <SpawnTable dataSource={spawns} />
              </Col>
            </Row>
            <Divider />
          </SectionSpacing>
        )}
      </div>
      <NavigationBtnContainer className="flex">
        <ButtonWrapper>
          <GeneralButton mobWidth="100%" type="functional" inverted={true} text="GO TO ACCOUNT SUMMARY" id="btnAccountSummary" onClick={handleExit}/>
          <GeneralButton mobWidth="100%" text="VIEW ALL EXCHANGES" id="btnViewExchanges" onClick={viewAllExchanges} />
        </ButtonWrapper>
      </NavigationBtnContainer>
    </div>
  );
};

Confirmation.propTypes = {
  userId: PropTypes.string,
  handleExit: PropTypes.func,
  handleBack: PropTypes.func,
  getInitialData: PropTypes.func,
  edit: PropTypes.bool,
  id: PropTypes.string,
  isLoading: PropTypes.bool
}

export default withRouter(Confirmation);
